import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";

export default function SelectLabels({ element, setElement, items }) {
  const handleChange = (event) => {
    setElement(event.target.value);
  };

  const BootstrapInput = styled(InputBase)(({ theme }) => ({
    "& .MuiInputBase-input": {
      borderRadius: "8px",
      position: "relative",
      backgroundColor: "#F1F1F1",
      border: "1px solid #8080808c",
      fontSize: 14,
      padding: "7px 26px 7px 12px",
      "&:focus": {
        borderRadius: 100,
      },
    },
  }));

  return (
    <div>
      <FormControl sx={{ minWidth: 132 }} variant="standard">
        <Select
          value={element}
          onChange={handleChange}
          displayEmpty
          input={<BootstrapInput />}
        >
          {items.map((itm, ind) => (
            <MenuItem key={ind} value={itm.value}>
              {itm.lable}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
